import axiosInstance from "../axiosClient";

export const sendSupportEmail = async (token,emailDetails) => {
  try {
    const response = await axiosInstance.post(`/email/support`, emailDetails,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    } );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendRequestPasswordEmail = async (emailDetails) => {
  try {
    const response = await axiosInstance.post(`/email/request-reset-password`, emailDetails );
    return response.data;
  } catch (error) {
    throw error;
  }
};